import {
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Modal,
  Popconfirm,
  Switch,
  Table,
  Tag,
  message,
} from "antd";
import { PlusOutlined, RedoOutlined, UndoOutlined } from "@ant-design/icons";
import { Divider, Radio, Slider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import Url from "../../apiCall/UrlConfig";
import moment from "moment-jalaali";
import { TypeList } from "../../component/utility";
import { useNavigate } from "react-router-dom";
//////Redux

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const ExamStudent = (props) => {
  const navigation = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);

  const [WidthDiv, setWidthDiv] = useState(0);
  const [StrokeWidth, setStrokeWidth] = useState(10);
  const [_showModalDetail, setshowModalDetail] = useState(false);
  const [listDetail, setListDetail] = useState([]);

  const canvasRef = useRef(null);
  let HbeW = 590 / 943;

  if (selectedRow != null && selectedRow?.patientImage?.imageWidth > 0) {
    HbeW =
      selectedRow?.patientImage?.imageHeight /
      selectedRow?.patientImage?.imageWidth;
  }

  const DivRef = useRef(null);
  const [_backgroudUrl, setBackgroundUrl] = useState("0");
  const [NumberTooth, setNumberTooth] = useState(null);
  const [TypeDetail, setTypeDetail] = useState(null);

  const Columns = [
    {
      title: "Jaw",
      render: (obj) => {
        return <Tag>{obj?.patientImage?.type}</Tag>;
      },
      width: 100,
    },
    {
      title: "Image",
      render: (obj) => {
        return (
          <img
            key={obj}
            src={ImagePreAddress + obj?.patientImage?.imageUrl}
            alt="maxilla"
            style={{ width: "70px" }}
          />
        );
      },
    },
    {
      title: "عملیات",
      render: (obj, item) => {
        return (
          <>
            <Button style={{ width: "70px" }} onClick={() => _selectedRow(obj)}>
              تشخیص
            </Button>
            {item?.patientImageDetail?.length > 0 && (
              <div>
                <Button
                  onClick={() => _onClickDetail(item)}
                  type="primary"
                  className="marin-vertical"
                >
                  مشاهده تشخیص خود
                </Button>
              </div>
            )}
          </>
        );
      },
    },
  ];

  const ColumnsImageDetail = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "شماره دندان", dataIndex: "numberTooth", key: "numberTooth" },
    { title: "مدل رسم", dataIndex: "typeDetail", key: "typeDetail", width: 50 },
    {
      title: "تاریخ رسم",
      dataIndex: "registerTime",
      key: "registerTime",

      render: (obj, item, index) => {
        return (
          <div>
            <div>{moment(obj).format("jYYYY-jMM-jDD")}</div>
            <div>{moment(obj).format("HH:mm")}</div>
          </div>
        );
      },
    },

    {
      title: "عملیات",
      dataIndex: "Action",
      key: "Action",

      render: (obj, item, index) => {
        return (
          <div>
            <Popconfirm
              title="Are you sure to delete this task?"
              onConfirm={(event) => {
                event.stopPropagation();
                _onClickDeleteDetail(item);
              }}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                onClick={(event) => {
                  // Prevent the click event from propagating to the row
                  event.stopPropagation();

                  // Your button click logic
                }}
              >
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    GetListExam();
  }, []);
  const GetListExam = async () => {
    const Result = await props.actions.CallCoreServicesActionWithToken(
      Url.GetListExam
    );

    if (Result.hasError) {
      message.error(Result.message);
      return;
    }

    console.log(Result?.data);
  };
  const _selectedRow = (item) => {
    setSelectedRow(item);
    console.log(item);
  };

  const _onClickDeleteDetail = async (item) => {
    let url = Url.DeleteImageDetailExam;
    const Result = await props.actions.CallCoreServicesActionWithToken(
      url,
      item
    );
    if (Result.hasError) {
      message.error(Result.message);
      return;
    }
    setshowModalDetail(false);
    GetListExam();
  };
  const _onClickDetail = (item) => {
    console.log(item);
    props.actions.OfflineCoreServices(
      Url.getImagDetailForExam,
      Url.action,
      null
    );

    setListDetail(item?.patientImageDetail);
    setshowModalDetail(true);
  };
  useEffect(() => {
    if (DivRef.current != null) {
      DivRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("width", DivRef.current.offsetWidth);

      let _width = DivRef.current.offsetWidth;
      if (_width > 500) {
        _width = 500;
      }
      setWidthDiv(_width);
      console.log("selected", selectedRow);
      setBackgroundUrl(ImagePreAddress + selectedRow.patientImage?.imageUrl);
    }
  }, [selectedRow]);

  useEffect(async () => {
    if (_backgroudUrl == "export") {
      let img = await canvasRef.current.exportImage("png");
      let PathCanvas = await canvasRef.current.exportPaths();
      setBackgroundUrl(ImagePreAddress + selectedRow.patientImage?.imageUrl);

      let _toServer = {
        NumberTooth: NumberTooth ? NumberTooth : "",
        TypeDetail,
        base64Masked: img,
        PathCanvas: JSON.stringify(PathCanvas),
        PatientImageId: selectedRow?.patientImage.id,
        widthImage: WidthDiv,
        heightImage: Math.floor(HbeW * WidthDiv),
        idExamrefrence: selectedRow?.id,
      };

      let url = Url.saveStudentDignous;

      let res = await props.actions.CallCoreServicesActionWithToken(
        url,
        _toServer
      );

      if (res.hasError) {
        message.error(res.message);
        return;
      }

      message.success("با موفقیت ثبت شد");
      GetListExam();
      canvasRef.current.resetCanvas();
    }
  }, [_backgroudUrl]);

  const _onPressAdd = async () => {
    if (
      NumberTooth == null &&
      !(TypeDetail == "ortho" || TypeDetail == "healthy")
    ) {
      message.warning("شماره دندان را انتخاب کنید ");
      return;
    }

    if (TypeDetail == null) {
      message.warning("نوع تشخیص را انتخاب کنید");
      return;
    }

    let PathCanvas = await canvasRef.current.exportPaths();

    if (PathCanvas.length == 0 && TypeDetail != "healthy") {
      message.warning("هیچ رسمی بر روی تصویر انجام نشده است ");
      return;
    }

    let base64Masked = await canvasRef.current.exportImage("png");

    setBackgroundUrl("export");
  };

  const _onClickRowImageDetail = async (item) => {
    const Result = await props.actions.CallCoreServicesActionWithToken(
      Url.getImagDetailForExam,
      item
    );

    console.log(Result);
    if (Result.hasError) {
      message.error(Result.message);
      return;
    }
  };

  return (
    <div>
      <Divider>آزمون صلاحیت تشخیص پوسیدگی</Divider>
      <Button type="primary" onClick={() => navigation("/demo")}>
        مشاهده دوباره ویدیو دمو
      </Button>
      <Table
        columns={Columns}
        dataSource={props.coreData[Url.GetListExam]?.[Url.action]?.data}
      />
      <Modal
        width="90%"
        open={_showModalDetail}
        onCancel={() => setshowModalDetail(false)}
      >
        <div>
          <Table
            columns={ColumnsImageDetail}
            dataSource={listDetail}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  _onClickRowImageDetail(record);
                }, // click row
              };
            }}
          />
        </div>
        {props.coreData[Url.getImagDetailForExam]?.[Url.action]?.data
          ?.patientImageDetail != null && (
          <>
            {" "}
            <img
              style={{
                width: "50%",
                backgroundImage:
                  "url(" +
                  ImagePreAddress +
                  props.coreData[Url.getImagDetailForExam]?.[Url.action]?.data
                    ?.patientImage.imageUrl +
                  ")",
                backgroundSize: "cover",
              }}
              src={
                props.coreData[Url.getImagDetailForExam]?.[Url.action]?.data
                  ?.patientImageDetail?.base64Masked
              }
            />
            <img
              style={{ width: "50%" }}
              src={
                ImagePreAddress +
                props.coreData[Url.getImagDetailForExam]?.[Url.action]?.data
                  ?.patientImage.imageUrl
              }
            />
          </>
        )}
      </Modal>

      {selectedRow != null && (
        <div>
          <div className="text-center">
            <img
              key={selectedRow}
              src={ImagePreAddress + selectedRow?.opgImage?.imageUrl}
              alt="opg"
              style={{ width: "300px" }}
            />
          </div>
          <div ref={DivRef}>
            {/* <img src={selectedRow.opg} alt="Jaw" style={{ width: "100%" }} /> */}
            <div className="flex-row">
              <div>اندازه قلم=</div>
              <div style={{ color: "red" }}>{StrokeWidth}</div>
              <Slider
                key={selectedRow}
                className="flex-1"
                min={1}
                max={20}
                onChange={(newStroke) => setStrokeWidth(newStroke)}
                value={StrokeWidth}
                // tooltip={{ open: true }}
              />
            </div>
            <div className="justify-center">
              <ReactSketchCanvas
                id={1}
                key={WidthDiv}
                style={{ width: WidthDiv, height: WidthDiv * HbeW }}
                ref={canvasRef}
                strokeWidth={StrokeWidth}
                strokeColor="black"
                exportWithBackgroundImage={true}
                backgroundImage={_backgroudUrl}
                preserveBackgroundImageAspectRatio={true}
              />
            </div>

            <Button onClick={() => canvasRef.current.undo()}>
              <UndoOutlined />
              undo
            </Button>
            <Button onClick={() => canvasRef.current.redo()}>
              <RedoOutlined />
              redo
            </Button>

            <div className="margin-top center-text">
              <div>شماره دندان (برای هر دندان جدا باید ثبت شود)</div>

              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                size="small"
                value={NumberTooth}
                onChange={(e) => setNumberTooth(e.target.value)}
              >
                <Radio value="8L">8</Radio>
                <Radio value="7L">7</Radio>
                <Radio value="6L">6</Radio>
                <Radio value="5L">5</Radio>
                <Radio value="4L">4</Radio>
                <Radio value="3L">3</Radio>
                <Radio value="2L">2</Radio>
                <Radio value="1L">1</Radio>
                <Divider type="vertical" />
                <Radio value="1R">1</Radio>
                <Radio value="2R">2</Radio>
                <Radio value="3R">3</Radio>
                <Radio value="4R">4</Radio>
                <Radio value="5R">5</Radio>
                <Radio value="6R">6</Radio>
                <Radio value="7R">7</Radio>
                <Radio value="8R">8</Radio>

                <div
                  className="margin-top"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div>دندان شیری</div>
                  <Radio value="EL">E</Radio>
                  <Radio value="DL">D</Radio>
                  <Radio value="CL">C</Radio>
                  <Radio value="BL">B</Radio>
                  <Radio value="AL">A</Radio>
                  <Divider type="vertical" />
                  <Radio value="AR">A</Radio>
                  <Radio value="BR">B</Radio>
                  <Radio value="CR">C</Radio>
                  <Radio value="DR">D</Radio>
                  <Radio value="ER">E</Radio>
                </div>
              </Radio.Group>
            </div>

            <div className="margin-top center-text">
              <div>تایپ رسم خود را مشخص کنید</div>
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                size="small"
                onChange={(e) => setTypeDetail(e.target.value)}
                value={TypeDetail}
              >
                {TypeList.map((o) => {
                  return <Radio value={o.value}>{o.title}</Radio>;
                })}
              </Radio.Group>
            </div>

            <div className="margin-top" style={{ textAlign: "center" }}>
              <Button
                loading={
                  props.coreData[Url.savePatintImageDetail]?.[Url.action]
                    ?.isFetching
                }
                onClick={_onPressAdd}
                type="primary"
              >
                افزودن <PlusOutlined />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ExamStudent);
